'use client';
import NextLink from 'next/link';

import { sizeClassnames, variantClassnames } from '@/server/components/Button/helpers';

import css from './Button.module.scss';

export const ButtonLink = ({
  href,
  children,
  disableDarkMode = false,
  variant,
  size = 'md',
  clipboardTarget,
}: {
  href: string;
  children: React.ReactNode;
  disableDarkMode?: boolean;
  variant: keyof typeof variantClassnames;
  size?: keyof typeof sizeClassnames;
  clipboardTarget?: string;
}) => {
  const buttonVersionClass = css.button;
  const respectDarkModeClass = disableDarkMode ? '' : css['respect-dark-mode'];

  const shouldCopy = !!clipboardTarget;
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (shouldCopy) {
      e.preventDefault();
      void (async () => {
        try {
          await navigator.clipboard.writeText(clipboardTarget);
        } catch (e) {
          throw Error('Your browser does not seem to support copying to clipboard');
        }
        window.location.replace(href);
      })();
    }
  };

  return (
    <NextLink
      href={href}
      target="_self"
      className={`${buttonVersionClass} ${variantClassnames[variant]} ${sizeClassnames[size]} ${respectDarkModeClass}`}
      legacyBehavior={shouldCopy}
      passHref={shouldCopy}
    >
      <>
        {shouldCopy && (
          <a
            href={href}
            className={`cta-button ${buttonVersionClass} ${variantClassnames[variant]} ${sizeClassnames[size]} ${respectDarkModeClass}`}
            onClick={onClick}
          >
            {children}
          </a>
        )}
        {!shouldCopy && <>{children}</>}
      </>
    </NextLink>
  );
};
